import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {getChatParticipantsNames} from 'ag-common/tools/chat'
import ChatMessagesList from '#components/m/Chat/ChatMessageList'
import ChatMessageInputField from '#components/m/Chat/ChatMessageInputField'
import ChatParticipantsList from '#components/m/Chat/ChatParticipantsList'
import ChatDetailHeader from '#components/m/Chat/ChatDetailHeader'

function ChatDetail({chat, submitMessage, isSubmitting}) {
  const [isShowingParticipants, setIsShowingParticipants] = useState(false)
  const participantsIncludingMyself = getChatParticipantsNames(chat, i18n.t('unknown_user'))
  participantsIncludingMyself.push({displayName: i18n.t('user_myself'), id: 'myself'})

  useEffect(() => {
    if (isShowingParticipants) {
      setIsShowingParticipants(false)
    }
  }, [chat.id])

  const chatMessageContent = () => (
    <>
      <ChatMessagesList chatId={chat.id} />
      <ChatMessageInputField submitMessage={submitMessage} isSubmitting={isSubmitting} />
    </>
  )

  return (
    <div className="chat-detail">
      <ChatDetailHeader
        isShowingParticipants={isShowingParticipants}
        setIsShowingParticipants={setIsShowingParticipants}
        participantsCount={participantsIncludingMyself.length}
        chat={chat}
      />
      {isShowingParticipants ? (
        <ChatParticipantsList participants={participantsIncludingMyself} />
      ) : (
        chatMessageContent()
      )}
    </div>
  )
}

ChatDetail.propTypes = {
  chat: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    participants: PropTypes.array.isRequired,
  }).isRequired,
  submitMessage: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
}

export default ChatDetail
